<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'FieldWithRC',
})
</script>
<template>
  <div :class="bem()">
    <div :class="bem('box')">
      <slot />
    </div>
    <IconBtn v-if="refreshVisible" tip="刷新" @click="$emit('refresh')"><ReloadOutlined /></IconBtn>
    <Button v-if="permision ? $permission(permision) : true" type="link" target="_blank" @click="$emit('create')">
      <template #icon><PlusCircleOutlined /></template>
      创建{{ title }}
    </Button>
  </div>
</template>

<script lang="ts" setup name="FieldWithRC">
import { ReloadOutlined, PlusCircleOutlined } from '@ant-design/icons-vue'
import { createNamespace } from '@bd/vue3-utils'
import { Button } from 'ant-design-vue'
import { IconBtn } from '-/Common/BdBtn'

withDefaults(
  defineProps<{
    title: string
    disabled?: boolean
    permision?: string
    refreshVisible?: boolean
  }>(),
  {
    disabled: false,
    refreshVisible: true
  }
)
defineEmits(['create', 'refresh'])
const [_, bem] = createNamespace('FieldWithRC')
</script>

<style lang="less">
.field-with-r-c {
  display: flex;

  &__box {
    flex: 1;
  }

  & > *:not(:last-child) {
    margin-right: @margin-md;
  }
}
</style>
